$(document).on('mouseenter', '.mod--location__select', function(event) {
    var location = $(this).data('location');

    $('.content__block.locations .active').removeClass('active');

    $(this).addClass('active');
    $('.mod--location__text[data-location="'+location+'"]').addClass('active');
});
